import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadDesignprocess'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'デザインプロセス デザインシステム コンポーネントライブラリ デザイン原則 デザインガイドライン figma'}
        image={'https://aitria.co.jp/images/img/download/design-process/ogp.png'}
        url={'https://aitria.co.jp/download/design-process/'}
        title="デザインプロセスガイドブック | 資料ダウンロード | Aitria（アイトリア）"
        description="デザインプロセスは、顧客体験価値の高いプロダクトやサービスを提供するために、私たちが実際に取り組んでいるプロセスを可視化した資料です。"
      />
      <Template />
    </>
  )
}

export default Download
